import React from "react";
import MultiSelect from "../../../components/MultiSelect";

export const SUBCATEGORIES = [
  { value: "BANK", label: "BANK", color: "bg-slate-100 text-slate-700 border border-slate-200" },
  { value: "TRAVEL", label: "TRAVEL", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  { value: "HOSTING", label: "HOSTING", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  { value: "OFFICE", label: "OFFICE", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  { value: "ADS", label: "ADS", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  { value: "ACCOUNTING", label: "ACCOUNTING", color: "bg-slate-100 text-slate-700 border border-slate-200" },
  { value: "TOOLS", label: "TOOLS", color: "bg-slate-100 text-slate-700 border border-slate-200" },
  { value: "FOODANDBEVERAGE", label: "FOODANDBEVERAGE", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  { value: "LEGAL", label: "LEGAL", color: "bg-slate-100 text-slate-700 border border-slate-200" },
  { value: "EXTERNAL_CONTRACTORS", label: "EXTERNAL_CONTRACTORS", color: "bg-slate-100 text-slate-700 border border-slate-200" },

  { value: "SALARY_FREELANCE", label: "SALARY_FREELANCE", color: "bg-blue-100 text-blue-700 border border-blue-200" },
  { value: "SALARY_EMPLOYEE", label: "SALARY_EMPLOYEE", color: "bg-blue-100 text-blue-700 border border-blue-200" },
  { value: "TAX_SALARY", label: "TAX_SALARY", color: "bg-blue-100 text-blue-700 border border-blue-200" },

  { value: "INVOICE", label: "INVOICE", color: "bg-green-100 text-green-700 border border-green-200" },
  { value: "VAT_INCOME", label: "VAT_INCOME", color: "bg-green-100 text-green-700 border border-green-200" },
  { value: "BUSINESS_INTRODUCER_INCOME", label: "BUSINESS_INTRODUCER_INCOME", color: "bg-green-100 text-green-700 border border-green-200" },
  { value: "SUBVENTION", label: "SUBVENTION", color: "bg-green-100 text-green-700 border border-green-200" },

  { value: "CORPORATION_TAX", label: "CORPORATION_TAX", color: "bg-red-100 text-red-700 border border-red-200" },
  { value: "VAT_DISBURSEMENT", label: "VAT_DISBURSEMENT", color: "bg-red-100 text-red-700 border border-red-200" },

  { value: "TRANSFER", label: "TRANSFER", color: "bg-indigo-100 text-indigo-700 border border-indigo-200" },
  { value: "INVEST", label: "INVEST", color: "bg-indigo-100 text-indigo-700 border border-indigo-200" },
  { value: "DIVIDEND", label: "DIVIDEND", color: "bg-indigo-100 text-indigo-700 border border-indigo-200" },

  { value: "IT_EQUIPMENT", label: "IT_EQUIPMENT", color: "bg-indigo-100 text-indigo-700 border border-indigo-200" },

  { value: "BANK_LOAN", label: "BANK_LOAN", color: "bg-red-100 text-red-700 border border-red-200" },

  { value: "", label: "", color: "bg-gray-100 text-gray-500 border border-gray-200" },
];

const FALLBACK_COLOR = "bg-gray-100 text-gray-500 border border-gray-200";

export const SubCategoryPill = ({ value }) => {
  if (!value) return null;
  const match = SUBCATEGORIES.find((c) => c.value === value);
  const color = match?.color || FALLBACK_COLOR;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${color}`}>{value}</span>;
};

export default ({ values = [], onChange }) => {
  return <MultiSelect values={values} id="select-subcategories" options={SUBCATEGORIES} onSelectedChange={onChange} placeholder="Select a subcategory" />;
};
